export default {"src":"__ASTRO_ASSET_IMAGE__9cV0fS2x__","width":72,"height":72,"format":"webp"}